import { types } from '../../types';

const setGetListLotteryAction = (payload) => {
  return {
    type: types.lottery.SET_LIST,
    payload,
  }
}

const setGetViewLotteryAction = (payload) => {
  return {
    type: types.lottery.SET_VIEW,
    payload
  }
}

const setGetStatLotteryAction = (payload) => {
  return {
    type: types.lottery.SET_STAT,
    payload
  }
}

const setGetPrizeLotteryAction = (payload) => {
  return {
    type: types.lottery.SET_PRIZE,
    payload
  }
}

const setGetWinnersLotteryAction = (payload) => {
  return {
    type: types.lottery.SET_WINNERS,
    payload
  }
}

export {
  setGetListLotteryAction as SetGetListLotteryAction,
  setGetViewLotteryAction as SetGetViewLotteryAction,
  setGetStatLotteryAction as SetGetStatLotteryAction,
  setGetPrizeLotteryAction as SetGetPrizeLotteryAction,
  setGetWinnersLotteryAction as SetGetWinnersLotteryAction
}